module.exports = __webpack_public_path__ + "static/media/view.3b0bd028.svg";